import _toConsumableArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { randomUUID, stringToUint8Array } from "@azure/core-util";
import { concat } from "../util/concat.js";
import { isBlob } from "../util/typeGuards.js";

function generateBoundary() {
  return "----AzSDKFormBoundary".concat(randomUUID());
}

function encodeHeaders(headers) {
  var result = "";

  var _iterator = _createForOfIteratorHelper(headers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      result += "".concat(key, ": ").concat(value, "\r\n");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function getLength(source) {
  if (source instanceof Uint8Array) {
    return source.byteLength;
  } else if (isBlob(source)) {
    // if was created using createFile then -1 means we have an unknown size
    return source.size === -1 ? undefined : source.size;
  } else {
    return undefined;
  }
}

function getTotalLength(sources) {
  var total = 0;

  var _iterator2 = _createForOfIteratorHelper(sources),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var source = _step2.value;
      var partLength = getLength(source);

      if (partLength === undefined) {
        return undefined;
      } else {
        total += partLength;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return total;
}

function buildRequestBody(_x, _x2, _x3) {
  return _buildRequestBody.apply(this, arguments);
}
/**
 * Name of multipart policy
 */


function _buildRequestBody() {
  _buildRequestBody = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, parts, boundary) {
    var sources, contentLength;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sources = [stringToUint8Array("--".concat(boundary), "utf-8")].concat(_toConsumableArray(parts.flatMap(function (part) {
              return [stringToUint8Array("\r\n", "utf-8"), stringToUint8Array(encodeHeaders(part.headers), "utf-8"), stringToUint8Array("\r\n", "utf-8"), part.body, stringToUint8Array("\r\n--".concat(boundary), "utf-8")];
            })), [stringToUint8Array("--\r\n\r\n", "utf-8")]);
            contentLength = getTotalLength(sources);

            if (contentLength) {
              request.headers.set("Content-Length", contentLength);
            }

            _context2.next = 5;
            return concat(sources);

          case 5:
            request.body = _context2.sent;

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _buildRequestBody.apply(this, arguments);
}

export var multipartPolicyName = "multipartPolicy";
var maxBoundaryLength = 70;
var validBoundaryCharacters = new Set("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'()+,-./:=?");

function assertValidBoundary(boundary) {
  if (boundary.length > maxBoundaryLength) {
    throw new Error("Multipart boundary \"".concat(boundary, "\" exceeds maximum length of 70 characters"));
  }

  if (Array.from(boundary).some(function (x) {
    return !validBoundaryCharacters.has(x);
  })) {
    throw new Error("Multipart boundary \"".concat(boundary, "\" contains invalid characters"));
  }
}
/**
 * Pipeline policy for multipart requests
 */


export function multipartPolicy() {
  return {
    name: multipartPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var _a, boundary, contentTypeHeader, parsedHeader, _parsedHeader, contentType, parsedBoundary;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (request.multipartBody) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", next(request));

              case 2:
                if (!request.body) {
                  _context.next = 4;
                  break;
                }

                throw new Error("multipartBody and regular body cannot be set at the same time");

              case 4:
                boundary = request.multipartBody.boundary;
                contentTypeHeader = (_a = request.headers.get("Content-Type")) !== null && _a !== void 0 ? _a : "multipart/mixed";
                parsedHeader = contentTypeHeader.match(/^(multipart\/[^ ;]+)(?:; *boundary=(.+))?$/);

                if (parsedHeader) {
                  _context.next = 9;
                  break;
                }

                throw new Error("Got multipart request body, but content-type header was not multipart: ".concat(contentTypeHeader));

              case 9:
                _parsedHeader = _slicedToArray(parsedHeader, 3), contentType = _parsedHeader[1], parsedBoundary = _parsedHeader[2];

                if (!(parsedBoundary && boundary && parsedBoundary !== boundary)) {
                  _context.next = 12;
                  break;
                }

                throw new Error("Multipart boundary was specified as ".concat(parsedBoundary, " in the header, but got ").concat(boundary, " in the request body"));

              case 12:
                boundary !== null && boundary !== void 0 ? boundary : boundary = parsedBoundary;

                if (boundary) {
                  assertValidBoundary(boundary);
                } else {
                  boundary = generateBoundary();
                }

                request.headers.set("Content-Type", "".concat(contentType, "; boundary=").concat(boundary));
                _context.next = 17;
                return buildRequestBody(request, request.multipartBody.parts, boundary);

              case 17:
                request.multipartBody = undefined;
                return _context.abrupt("return", next(request));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x4, _x5) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}